import { ProductRequestStatusType } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { DropdownField, DropdownOption } from '@components/common/Fields/Dropdown';
import { ExtendedChip } from '@components/common/chip/Chip';
import { Box } from '@mui/material';
import { t } from '@translations';
import { useMemo, useState } from 'react';

type ProductRequestStatusProps = {
  currentStatus?: ProductRequestStatusType;
  handleDropdownChange: (value: ProductRequestStatusType) => void;
  canChangeStatus?: boolean;
};

export const ProductRequestStatus: React.FC<ProductRequestStatusProps> = ({
  currentStatus,
  handleDropdownChange,
  canChangeStatus,
}: ProductRequestStatusProps) => {
  const [status, setStatus] = useState<ProductRequestStatusType>(currentStatus || '');

  const options = useMemo<DropdownOption<ProductRequestStatusType>[]>(
    () => [
      { label: t(TextCodes.ProductRequest.Status.Open), value: 'Open' },
      { label: t(TextCodes.ProductRequest.Status.Resolved), value: 'Resolved' },
    ],
    []
  );
  const handleStatusChange = (value: ProductRequestStatusType) => {
    handleDropdownChange(value);
    setStatus(value);
  };

  return currentStatus && canChangeStatus ? (
    <Box sx={{ width: '150px' }}>
      <DropdownField
        options={options}
        label={t(TextCodes.ProductRequest.Base.Status)}
        getValue={handleStatusChange}
        value={status}
      />
    </Box>
  ) : (
    <ExtendedChip label={status} size='large' />
  );
};
